/**
 * Formats a date value into a localized date string.
 *
 * @param value - Date value (ISO string, timestamp, or Date)
 * @param locale - Locale string (default: "en-GB")
 * @returns Formatted date string (e.g., "30/12/2025") or "-" if invalid
 */
export const formatDate = (
	value: string | number | Date | null | undefined,
	locale: string = 'en-GB'
): string => {
	if (!value) return '-';

	const date = new Date(value);

	if (isNaN(date.getTime())) return '-';

	return date.toLocaleDateString(locale);
};